var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shelves-box"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/qietu/appshelves.png"),"alt":""}}),_c('p',[_vm._v("已下架")])])])
}]

export { render, staticRenderFns }